











import Vue from "vue";
import AppHeader from "./components/AppHeader.vue";
import ColourConverter from "./components/ColourConverter.vue";

export default Vue.extend({
  name: "App",
  components: {
    AppHeader,
    ColourConverter,
  },
  data: () => ({
    BaseHue: 0,
  }),
  computed: {
    AppStyle: function() {
      return { backgroundColor: `hsl(${this.BaseHue}, 80%, 98%)` };
    },
    ComplementaryHue: function() {
      return this.BaseHue + (180 % 360);
    },
  },
  created() {
    this.changeColour();
  },
  methods: {
    changeColour() {
      this.BaseHue = Math.floor(Math.random() * 360);
    },
  },
});
